import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import FormSection from '../layout/FormSection';
import GridContainer from './GridContainer';


const BatchOperationFeedback = ({ errors, setErrors }) => (
  <FormSection
    title={(
      <>
        <FontAwesomeIcon
          icon={faExclamationCircle}
          style={{
            color: '#D32D2D',
            fontSize: '1rem',
            marginRight: '5px'
          }}
        />
        Errores
        <Button
          onClick={() => setErrors([])}
          close
        />
      </>
    )}
    titleStyle={{ fontSize: '1.1rem', marginBottom: '3px' }}
  >
    <GridContainer
      columns="50px auto"
      gap="2px"
      style={{
        fontSize: '14px',
        maxHeight: '100px',
        overflow: 'auto',
        borderBottom: '1px solid rgba(0,0,0,.1)'
      }}
    >
      {errors.map(error => (
        <React.Fragment key={error.row}>
          <div>
            {`Fila ${error.row}`}
            :
          </div>
          <div>
            {error.message}
          </div>
        </React.Fragment>
      ))}
    </GridContainer>
  </FormSection>
);

BatchOperationFeedback.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.number,
      message: PropTypes.string,
    })
  ).isRequired,
  setErrors: PropTypes.func.isRequired,
};

export default BatchOperationFeedback;
